import { render, staticRenderFns } from "./inbound-exception-expand.vue?vue&type=template&id=c3870704&scoped=true&"
import script from "./inbound-exception-expand.vue?vue&type=script&lang=js&"
export * from "./inbound-exception-expand.vue?vue&type=script&lang=js&"
import style0 from "./inbound-exception-expand.vue?vue&type=style&index=0&id=c3870704&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3870704",
  null
  
)

export default component.exports